import { render } from "./LogoSpinner.vue?vue&type=template&id=73ece8e4&scoped=true"
const script = {}

import "./LogoSpinner.vue?vue&type=style&index=0&id=73ece8e4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ece8e4"]])

export default __exports__